<template>
  <div id="store">
    <div class="store-container">
      <ui-box>
        <template v-slot:nav-left>
          <ui-tag
            v-for="(tab, index) in tabs" 
            :key="index"
            :id="tab.type"
            :active="activeTab === tab.type"
            :class="['tab', tab.type]"
            :data-id="`id-${index}`"
            @click.native="toggle(tab.type)"
          >
            <div v-show="!isInterdict" class="tanc" @click="handleClickshowRank"></div>
            <div class="label-box">
              <span class="label-shadow">{{ tab.name }}</span>
              <span class="label-text">{{ tab.name }}</span>
            </div>
            <TipDot
              v-if="tab.type == 'task' &&  showLingqu.taskHots.shopTask"
              placement="activity"
            ></TipDot>
            <TipDot
              v-if="tab.type == 'mall' &&  showLingqu.taskHots.shopList"
              placement="mall"
            ></TipDot>
            <TipDot
              v-if="tab.type == 'dedicate' &&  showLingqu.taskHots.shopCumul"
              placement="dedicate"
            ></TipDot>
          </ui-tag>
        </template>
        <template v-slot:nav-right>
          <div class="right-mode">
            <div class="right-box" v-if="activeTab == 'mall'"> 
              <ui-frame-bg class="history-btn" colorType="green" hook @click.native="handleHistory">
                <i></i>
                <div class="label-box">
                  <span class="label-shadow">兑换记录</span>
                  <span class="label-text">兑换记录</span>
                </div>
              </ui-frame-bg>
            </div>
            <!-- <div class="times" v-if="activeTab == 0 && countdown != 0" > 任务刷新：{{ this.countdown }}</div> -->
          </div>
        </template>
        <template v-slot:container>
          <div class="commodity-box" :class="activeTab">
            <router-view />
          </div>
        </template>
      </ui-box>
    </div>

    <History ref="history"></History>
    <rnkingRewards ref="rnkingRewards"></rnkingRewards>
    <Exchange ref="exchange"></Exchange>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import * as api from "@/service/index";
import UiBox from '@/components/ui-box';
import UiTag from '@/components/ui-tag';
import UiFrameBg from '@/components/ui-frame-bg';
import History from '@/views/store/history'
import TipDot from '@/components/tip-dot.vue'
import rnkingRewards from '@/views/ranking/rnking-rewards.vue'
import Exchange from '@/views/store/exchange'

export default {
  components: {
    UiBox,
    UiTag,
    UiFrameBg,
    History,
    TipDot,
    rnkingRewards,
    Exchange,
  },
  data() {
    return {
      activeTab: 'task',
      // url_pre: 'https://website.xdcdn.net/module/sausage-match/images',
      tabs : [
        { name: '任务', type: "task" },
        { name: '商城', type: "mall" },
        { name: '累计人气贡献', type: "dedicate" },  
      ],
      countdown: '加载中...'
    }
  },
  computed: {
    ...mapState(['amount', 'token','showLingqu','isInterdict', 'popupStatus'])
  },
  watch: {
    'countdown': {
      handler() {
        this.formatCountdown()
      },
      immediate: true
    },
    'popupStatus': {
      handler(newVal, oldVal) {
        if(newVal && newVal != oldVal){
          if(newVal.id == 'exchange'){
            let goodList = newVal.params?.goodList;
            let type = newVal.params?.type;
            this.$refs.exchange.exchange(goodList, type)
          }
        }
      }
    }
  },
  created() {
    this.formatCountdown()
  },
  beforeMount(){
    this.activeTab = this.$route.path.split('/')[2]
  },
  methods: {
    ...mapActions(["reqUserInfo",'reqRedDotState']),
    handleHistory() {
      this.$refs.history.history()
    },
    handleClickshowRank(){
      this.$refs.rnkingRewards.getAmount()
    },
    async formatCountdown() {
      try {
        const  now = await api.reqcurrentTime()
        if(now.status == 200){
          const targetTime = this.amount.part2StartTime * 1000;
          const currentTime = new Date(now.data).getTime();
          const timeDifference = targetTime - currentTime;

          if (timeDifference <= 0) {
            this.countdown = 0 
            return
          }
          const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24)); // 计算剩余天数
          const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // 计算剩余小时
          
          this.countdown =   `${days}日${hours}时`;
        }
      }catch(err){
        console.log(err)
      }
    },
    toggle(type){
      if(this.activeTab == type) return;

      this.activeTab = type
      // TODO 二阶段开
      if(type !== 'dedicate'){
        this.reqRedDotState()
      }
      // 跳转子路由
      this.$router.push({
        path: `/store/${type}`
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/store/index';
</style>